<script lang="ts" setup>
	const props = defineProps<{
		time?: number
	}>()

	const STORAGE_KEY = 'countdown-time'
	const defaultDuration = props.time ?? 120 // default 120 seconds

	const now = () => Date.now()
	const endTime = ref<number | null>(null)
	const remaining = ref(0)

	let timer: NodeJS.Timeout | undefined

	const updateRemaining = () => {
		if (endTime.value) {
			const diff = Math.max(0, Math.floor((endTime.value - now()) / 1000))
			remaining.value = diff
			if (diff <= 0) {
				clearInterval(timer)
				localStorage.removeItem(STORAGE_KEY)
			}
		}
	}
	const startCountdown = () => {
		const storedEndTime = localStorage.getItem(STORAGE_KEY)
		if (storedEndTime) {
			endTime.value = parseInt(storedEndTime)
		} else {
			const newEndTime = now() + defaultDuration * 1000
			endTime.value = newEndTime
			localStorage.setItem(STORAGE_KEY, newEndTime.toString())
		}

		updateRemaining()
		timer = setInterval(updateRemaining, 1000)
	}
	const stopCountDown = () => {
		clearInterval(timer)
		localStorage.removeItem(STORAGE_KEY)
	}
	onMounted(startCountdown)
	onUnmounted(stopCountDown)

	const minutes = computed(() => Math.floor(remaining.value / 60))
	const seconds = computed(() => remaining.value % 60)
	defineExpose({
		startCountdown,
		stopCountDown,
		minutes,
		seconds
	})
</script>

<template>
	<span>
		<span v-if="remaining > 0" class="text-primary-2">
			{{ String(minutes).padStart(2, '0') }}:{{ String(seconds).padStart(2, '0') }}
		</span>
		<span v-else><slot>Resend</slot></span>
	</span>
</template>
